import type { DecisionTreeComponent } from "./decision-tree.component";

type DisplayOptions = Pick<
  DecisionTreeComponent,
  "hasSellout" | "hasVilcRef" | "isYtd" | "skuRecommendationVersion"
>;

export function getDecisionTreeImageKey(options: DisplayOptions): string {
  const sellout = options.hasSellout ? "sellout" : "nosellout";
  const vilc = options.hasVilcRef ? "vilc" : "novilc";
  const version = options.skuRecommendationVersion.toLowerCase();
  const ytdPrefix =
    options.isYtd && options.skuRecommendationVersion === "V3" ? "ytd-" : "";
  return `${ytdPrefix}${sellout}-${vilc}-${version}`;
}

export function getDecisionTreeWarningIconClass(
  options: DisplayOptions,
): string {
  const vilcRef = options.hasVilcRef ? "with-vilc-ref" : "without-vilc-ref";
  return `warning-icon-${vilcRef}-${options.skuRecommendationVersion}`;
}

export function getDecisionTreeClass(options: DisplayOptions): string {
  const sellout = options.hasSellout ? "has-sellout" : "no-sellout";
  const vilcRef = options.hasVilcRef ? "has-vilcRef" : "no-vilcRef";
  const version = options.skuRecommendationVersion;
  return `${sellout}-${vilcRef}-${version}`;
}
